//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Version: 1.3 */
import { mapState } from "vuex";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import QAuModelPicker from "../ModelPicker/qAuModelPicker.vue";

export default {
    name: "AQTreeConfigItem",
    components: {
        QAuModelPicker,
        AQChip
    },
    props: {
        dataItem: {
            type: Array,
            default: () => []
        },
        parentTree: {
            type: Object,
            default: () => ({})
        },
        baseArray: {
            type: String,
            default: ""
        },
        section: {
            type: String,
            default: ""
        },
        noIdentation: {
            type: Boolean,
            default: false
        },
        hideDMPicker: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            constraints: {},
            basePathValue: null,
            currentElem: null,
            indexParent: null,
            iconProps: {
                name: "keyboard_arrow_down"
            },
            customKey: 0
        };
    },
    computed: {
        ...mapState("diagrams", ["isFromResponse"]),
        setConstraints() {
            const constrToSend = {};

            if (this.currentElem) {
                const currentElemType = this.currentElem.type.toLowerCase();
                constrToSend.types = [currentElemType];

                if (currentElemType === "string") {
                    constrToSend.types.push("date", "time", "datetime");

                    if (!this.isFromResponse && (!this.section || this.section === "BODY")) {
                        constrToSend.types.push("attachment", "boolean", "integer", "decimal");
                    }
                }

                if (this.currentElem.isSimpleList) {
                    constrToSend.types.push("simpleList");
                }
            }

            return constrToSend;
        },
        localBaseArray() {
            let currentBaseArray = this.baseArray || null;
            if (this.parentTree && this.parentTree.type && this.parentTree.type === "list"
                && this.parentTree.value && this.parentTree.value.length) {
                currentBaseArray = this.parentTree.value.replaceAll("[]", "");
            }

            return currentBaseArray;
        }
    },
    methods: {
        sendExpandState(val) {
            return !(val.type === "string" && this.isFromResponse);
        },
        itemEntryIconName(value) {
            let icon = "mdi-circle-small";
            if (value.children && value.children.length) {
                icon = value.children[0].hide ? "mdi-menu-right" : "mdi-menu-down";
            }

            return icon;
        },
        changeDataModel(child, idx) {
            this.indexParent = idx;
            this.currentElem = child;
            this.basePathValue = this.localBaseArray;
        },
        onModelSelect(modelSelect) {
            if (modelSelect) {
                this.currentElem.value = this.currentElem.value === modelSelect.formatted ? "" : modelSelect.formatted;
                this.emitNewSelection(this.dataItem[this.indexParent], modelSelect.model);
                if (this.dataItem[this.indexParent].type === "list") {
                    this.resetChildrenValue([this.dataItem[this.indexParent]]);
                }
                this.hidePopover();
                this.customKey += 1;
            }
        },
        resetChildrenValue(currentDataItem, kids) {
            for (let k = 0; k < currentDataItem.length; k++) {
                if (kids && currentDataItem[k].value.length) {
                    currentDataItem[k].value = "";
                    this.emitNewSelection(currentDataItem[k]);
                }
                if (currentDataItem[k] && currentDataItem[k].children && currentDataItem[k].children.length) {
                    for (let i = 0; i < currentDataItem[k].children.length; i++) {
                        if (currentDataItem[k].children[i].value.length) {
                            currentDataItem[k].children[i].value = "";
                            this.emitNewSelection(currentDataItem[k].children[i]);
                        }
                        if (currentDataItem[k].children[i].children && currentDataItem[k].children[i].children.length) {
                            this.resetChildrenValue(currentDataItem[k].children[i].children, true);
                        }
                    }
                }
            }
        },
        emitNewSelection(item, val) {
            if (item) {
                this.$root.$emit("sendRequestResponse", {
                    routeName: this.$route.name,
                    newDataItem: { ...item, ...{ valueNotFormatted: val || "" } }
                });
            }
        },
        onClickItemIcon(value) {
            if (value.children && value.children.length) {
                for (let i = 0; i < value.children.length; i++) {
                    value.children[i].hide = !value.children[i].hide;
                    if (value.children[i].children && value.children[i].hide) {
                        this.hideChildren(value.children[i].children);
                    }
                }
                this.emitNewHide(value);
            }
        },
        hideChildren(value) {
            for (let i = 0; i < value.length; i++) {
                value[i].hide = true;
                if (value[i].children) {
                    this.hideChildren(value[i].children);
                }
            }
        },
        emitNewHide(item) {
            if (item) {
                const hideObj = {
                    routeName: this.$route.name,
                    newDataHide: {}
                };
                hideObj.newDataHide[item.fullPath] = item.children[0].hide;
                this.$root.$emit("sendRequestResponseHide", hideObj);
            }
        },
        hidePopover() {
            for (let i = 0; i < this.$refs.popoverRef.length; i++) {
                this.$refs.popoverRef[i].hide();
            }
        }
    }
};
